import en from './pos.en';

const enConfig = { en };

export default enConfig;
